import './App.scss';
import UIContainer from './components/UIContainer/UIContainer';

function App() {
  return (
    <div className="App">
      <UIContainer />
    </div>
  );
}

export default App;
